/* eslint-disable */
'use strict';

const HIDDEN_CLASS = 'h-hidden';

var util = {
    /**
     * @function
     * @description appends parameter to the location hash
     * @param {string} name the name of the parameter
     * @param {string} value the value of the parameter
     * @returns {string} new hash
     */
    addHashToURL: function (name, value) {
        if (!name || !value) {
            return null;
        }
        let hashParams = window.location.hash.length ? this.getHashParams(window.location.hash) : {};
        hashParams[name] = value;
        const newHash = Object.keys(hashParams).reduce((result, key) => {
            result += key + '=' + hashParams[key] + '&';
            return result;
        }, '#').replace(/&$/, '');
        if (history.pushState) {
            history.pushState(null, null, newHash);
        } else {
            location.hash = newHash;
        }
        return window.location.hash;
    },
    /**
     * @function
     * @description appends parameter to the location hash
     * @param {string} name the name of the parameter
     * @returns {string} new hash
     */
    removeHashFromURL: function (name) {
        if (!name) {
            return null;
        }
        let hashParams = window.location.hash.length ? this.getHashParams(window.location.hash) : {};
        delete hashParams[name];
        const newHash = Object.keys(hashParams).reduce((result, key) => {
            result += key + '=' + hashParams[key] + '&';
            return result;
        }, '#').replace(/&$/, '');
        if (history.pushState) {
            history.pushState(null, null, newHash);
        } else {
            location.hash = newHash;
        }
        return window.location.hash;
    },
    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {string} url the url to which the parameter will be added
     * @param {string} name the name of the parameter
     * @param {string} value the value of the parameter
     * @returns {string} url with parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description search parameter value from the given url
     * @param {string} url the url to which the parameter search
     * @param {string} parameter the name of the parameter
     * @returns {string} parameter value or empty string
     */
    getParameterValue: function (url, parameter) {
        url = url && url.toString() || '';
        var value = url.match(parameter + '\\=(.*?[^&#]*)');
        if (value && value[1]) {
            return value[1];
        }
        return '';
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {string} url the url from which the parameter will be removed
     * @param {string} name the name of parameter that will be removed from url
     * @returns {string} url without parameter
     */
    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }

        var paramsString = newParams.length > 0 ? '?' + newParams.join('&') : '';

        return domain + paramsString + (hash ? '#' + hash : '');
    },
    /**
     * @function
     * @description replace the parameter with the given name by new value and returns the changed url
     * @param {string} url the url to which the parameter will be added
     * @param {string} name the name of the parameter
     * @param {string} value the new value of the parameter
     * @returns {string} url with parameter
     */
    replaceParameterInUrl: function (url, name, value) {
        url = this.removeParamFromURL(url, name);
        return this.appendParamToURL(url, name, value);
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {string} url the url to which the parameters will be added
     * @param {Object} params object with parameters to pass in url
     * @returns {string} url with additional params
     */
    appendParamsToUrl: function (url, params) {
        var selfUrl = url;
        $.each(params, (name, value) => {
            selfUrl = this.appendParamToURL(selfUrl, name, value);
        });
        return selfUrl;
    },

    /**
     * @function
     * @description replace parameter in given query string 'a=3&b=4'
     * @param {string} queryString the query string given
     * @param {string} name the name of the parameter
     * @param {string} value the value of the parameter
     * @returns {string} new query string
     */
    replaceParamInQueryString(queryString, name, value) {
        var queryArray = queryString.split('&');

        if (queryString.indexOf(name + '=') !== -1) {
            for (let i = 0, len = queryArray.length; i < len; i++) {
                var parts = queryArray[i].split('=');
                if (parts[0] === name) {
                    queryArray[i] = `${name}=${value}`;
                }
            }
        } else {
            queryArray.push(`${name}=${value}`);
        }
        return queryArray.join('&');
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {string} url the url to extra query string from
     * @returns {string} url queries
     **/
    getQueryString: function (url) {
        var qs;
        if (typeof url !== 'string') {
            return '';
        }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    /**
     * @function
     * @description get absolute url
     * @param {string} url url
     * @returns {string} abosolute url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {string} url The url from which css file will be dynamically loaded.
     * @returns {jQuery} append to head file with styles
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i) {
            $(this.loadedCssFiles[i]).remove();
            i--;
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {string} qs The query string from which the parameters will be extracted
     * @returns {Object} query params
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) {
            return {};
        }
        var params = {};
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        qs.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            ($0, $1, $2, $3) => {
                params[$1] = decodeURIComponent($3).replace(/\+/g, ' ');
            }
        );
        return params;
    },

    getParameterValueFromUrl: function(parameterName, url) {
        var currentQueryString = url || window.location.search;
        var currentQueryStringParams = this.getQueryStringParams(currentQueryString);

        return currentQueryStringParams[parameterName];
    },

    eventDelay: function(callback, threshhold, scope, skipInitialCall) {
        threshhold = threshhold || 250;
        var last,
            deferTimer;

        return function() {
            var context = scope || this,
                now = (new Date()).getTime(),
                args = arguments;

            if (last && now < last + threshhold) {
                clearTimeout(deferTimer);
                deferTimer = setTimeout(() => {
                    last = now;
                    callback.apply(context, args);
                }, threshhold);
            } else {
                last = now;

                if (!skipInitialCall) {
                    callback.apply(context, args);
                }
            }
        };
    },

    /**
     * @description Throttling Function Calls
     * @param {Function} callback Callback function to call
     * @param {number} delay Delay before callback fire
     * @param {Object} [scope] The context to for callback fire
     * @returns {Function} return throttled function
     */
    throttle: function(callback, delay, scope) {
        var timeout = null;
        return function(...args) {
            if (!timeout) {
                timeout = setTimeout(() => {
                    callback.call(scope, ...args);
                    timeout = null;
                }, delay || 100);
            }
        };
    },

    getTimer: function() {
        return {
            id: null,
            clear: function () {
                if (this.id) {
                    window.clearTimeout(this.id);
                    delete this.id;
                }
            },
            start: function (duration, callback) {
                this.id = setTimeout(callback, duration);
            }
        };
    },

    /**
     * @description Add/remove value from array depending on its existing in array
     * @param {Array} inArr array
     * @param {any} value value to delete
     * @returns {Array} array without value
     */

    toggleFromArray: function(inArr, value) {
        var arr = inArr.slice();
        var valueIndex = arr.indexOf(value);
        if (valueIndex >= 0) {
            arr.splice(valueIndex, 1);
        } else {
            arr.push(value);
        }

        return arr;
    },

    /**
     * Helper function.
     * @description Checks if two arrays have the same values. It doesn't depend from order
     * @param {Array} arr1 first array
     * @param {Array} arr2 second array
     * @returns {Boolean} if array equal
     */

    arraysEqualByValues: function(arr1, arr2) {
        if (!arr1 || !arr2) {
            return arr1 === arr2;
        }

        var len1 = arr1.length,
            len2 = arr2.length;

        if (len1 !== len2) {
            return false;
        }
        for (var i = 0; i < len1; i++) {
            if (arr2.indexOf(arr1[i]) < 0) {
                return false;
            }
        }

        return true;
    },

    getKeyByValue: function(HashMapCollection, value) {
        for (var prop in HashMapCollection) {
            if (HashMapCollection.hasOwnProperty(prop)) {
                if (HashMapCollection[prop] === value) {
                    return prop;
                }
            }
        }
        return null;
    },

    /**
     * @description get Uri object
     * @param  {HTMLElement|string} o element/string
     * @returns {Object} URI object
     */

    getUri: function(o) {
        var a;

        if (o.tagName && $(o).attr('href')) {
            a = o;
        } else if (typeof o === 'string') {
            a = document.createElement('a');
            a.href = o;
        } else {
            return null;
        }

        // overcome some stupid ie behaviour
        if (a.host === '') {
            /* eslint-disable no-self-assign */
            a.href = a.href;
        }

        // all actual version of IE not so smart to correctly process
        // protocol independent locations, so wee need to help them
        if (a.protocol === ':') {
            a.protocol = window.location.protocol;
        }

        // fix for some IE browsers
        if (a.pathname.indexOf('/') !== 0) {
            a.pathname = '/' + a.pathname;
        }

        return Object.create({
            protocol: a.protocol, //http:
            host: a.host, //www.myexample.com
            hostname: a.hostname, //www.myexample.com'
            port: a.port, //:80
            path: a.pathname, // /sub1/sub2
            query: a.search, // ?param1=val1&param2=val2
            queryParams: a.search.length > 1 ? this.getQueryStringParams(a.search.substr(1)) : {},
            hash: a.hash, // #OU812,5150
            url: a.protocol + '//' + a.host + a.pathname,
            toString: function () {
                return this.protocol + '//' + this.host + this.port + this.pathname + this.search + this.hash;
            }
        });
    },

    getRootUri: function (relativeUrl) {
        var pathname = window.location.pathname,
            pathMatch = pathname.match(/(\/s\/[^/]+)\/?/),
            sitePath = '';

        if (pathMatch) {
            sitePath = pathMatch[1];
        }
        return sitePath + relativeUrl;
    },

    format: function () {
        var s = arguments[0],
            len = arguments.length - 1,
            i,
            reg;

        for (i = 0; i < len; i++) {
            reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return String(s);
    },

    decodeHtml: function (str) {
        var result = str || '';

        result = result.replace(/\\"/gi, '"');
        result = result.replace(/&amp;/g, '&');
        result = result.replace(/&lt;/g, '<');
        result = result.replace(/&gt;/g, '>');

        return String(result);
    },

    pad: function (num, size) {
        var s = num + '';
        while (s.length < (size || 2)) {
            s = '0' + s;
        }
        return s;
    },

    renderTemplate(templateString, data) {
        return templateString.replace(/\{\{([^}]+)\}\}/g, (match, attr) => {
            return data[attr] || '';
        });
    },

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    },

    getHashParams(hash) {
        hash = hash.replace('#', '').split('&');

        var data = {}, parts;
        for (var i = 0; i < hash.length; i++) {
            parts = hash[i].split('=');
            if (parts.length < 2) {
                parts.push('');
            }
            data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
        }
        return data;
    },
    extendOneLevelDeep(target = {}, source = {}) {
        Object.keys(source).forEach((key) => {
            var sourceVal = source[key],
                sourceType = typeof sourceVal;

            if (sourceVal && sourceType === 'object') {
                var isArray = $.isArray(sourceVal);
                var objectOrArray = isArray ? [] : {};

                target[key] = $.extend(target[key] || objectOrArray, sourceVal);
            } else if (sourceType !== 'undefined') {
                target[key] = sourceVal;
            }
        });
        return target;
    },
    /**
     * @description Access given properties of an object recursively
     * @param {Object} object The object
     * @param {string} propertyString The property string, i.e. 'data.myValue.prop1'
     * @param {Object} fallBackValue negative case value
     * @returns {Object} The value of the given property or undefined
     * @example var prop1 = require('./utils').resolve(obj, 'data.myValue.prop1')
     */
    resolve(object, propertyString, fallBackValue) {
        var result = object;
        var propPath = propertyString.split('.');

        propPath.forEach((prop) => {
            if (result && typeof result === 'object' && prop in result) {
                result = result[prop];
            } else {
                result = null;
            }
        });
        if (!result && typeof fallBackValue !== 'undefined') {
            result = fallBackValue;
        }

        return result;
    },
    /**
     * @description Genereal wrapper for JSON.parse(...) with error catching
     * @param {string} stringified The string object representation to parse.
     * @param {Object} defaultObject default value
     * @returns {Object} parse JSON
     */
    parseJson: function (stringified, defaultObject) {
        var parsed = {};

        if (!stringified) {
            return defaultObject || {};
        }

        try {
            parsed = JSON.parse(stringified);
        } catch (e) {
            return defaultObject || {};
        }

        return parsed;
    },
    formatMoney(format, value) {
        if (typeof value === 'number') {
            value = value.toFixed(2);
        }
        return format.replace(/0(\.0+|,0+)?/g, value);
    },
    getPriceValue(priceObj) {
        if (priceObj.type === 'range') {
            return priceObj.min.sales.value;
        } else if (priceObj.sales && priceObj.sales.value) {
            return priceObj.sales.value;
        }
        return 0;
    },
    show($el) {
        $el.removeClass(HIDDEN_CLASS);
    },
    hide($el) {
        $el.addClass(HIDDEN_CLASS);
    },
    decodeAllHtml(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    },

    /**
     * Make input tags of type "tel" only accept numbers, "-" and "+" symbols.
     */
    checkTelFields: function () {
        var $telFields = $('input[type=tel]');

        $telFields.on('input', function (e) {
            var $target = $(e.target);

            $target.val($target.val().replace(/[^\d-+]/g, ''));
        });
    }
};

module.exports = util;
